/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import styled from "styled-components";

const container = styled.div`
  max-width: 1200px;
  margin: 0 auto;

  @media (max-width: 1220px) {
    padding-left: 2rem;
    padding-right: 2rem;
  }
`;

export default container;
